import {  Descriptions, Drawer } from "antd";
import parse from "html-react-parser";

import moment from "moment";

function ViewDetail(props: any) {
  let { openViewDetail, setOpenViewDetail, dataViewDetail } =
    props;
  const onClose = () => {
    setOpenViewDetail(false);
  };
  return (
    <>
      <Drawer
        title="Chức năng xem chi tiết"
        width={"50vw"}
        onClose={onClose}
        open={openViewDetail}>
        <Descriptions title="Thông tin vai trò" bordered column={2}>
          <Descriptions.Item label="ID">
            {dataViewDetail?._id}
          </Descriptions.Item>
          <Descriptions.Item label="Tên">
            {dataViewDetail?.name}
          </Descriptions.Item>
          <Descriptions.Item labelStyle={{minWidth: "110px"}} label="Miêu tả" className={`html_react_parser`}>
            {parse(dataViewDetail?.description || "")}
          </Descriptions.Item>
          <Descriptions.Item label="IsActive">
            {`${dataViewDetail?.isActive}`}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày tạo">
            {moment(dataViewDetail?.createdAt).format("DD-MM-YY HH:mm:ss")}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày cập nhật">
            {moment(dataViewDetail?.updatedAt).format("DD-MM-YY HH:mm:ss")}
          </Descriptions.Item>
        </Descriptions>
      </Drawer>
    </>
  );
}

export default ViewDetail;
